import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { toggleItem } from 'redux/toolbar';
import Icon from './Icon';
import Toolbar from './Toolbar';

const LizzySidebar = () => {
  /* Helpers */
  const dispatch = useDispatch();

  /* Selectors */
  const isSidebarOpen = useSelector((state) => state.toolbar.itemStatus['sidebar'].active);
  
  /* Functions */
  const handleCloseSidebar = () => {
    dispatch(toggleItem({ itemKey: 'sidebar' }));
  };

  /* Render */
  if (!isSidebarOpen) {
    return <></>;
  }

  return (
    <Wrapepr>
      <Header>
        <Icon source='lizzy' name='lizzy-logo-colored-text' className='logo' />
        <Icon source='feather' name='x' className='close' onClick={handleCloseSidebar} />
      </Header>

      <ToolbarWrapper>
        <Toolbar />
      </ToolbarWrapper>
    </Wrapepr>
  );
}

export default LizzySidebar;

const Wrapepr = styled.aside`
  min-width: 388px;
  max-width: 388px;
  background-color: var(--lizzy-white);
  box-shadow: 0px 0px 58px rgba(17, 17, 17, 0.1);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 13px;
  border-bottom: 1px solid var(--lizzy-black-10);
  max-height: 18px;

  .logo {
    height: 20px;
    width: 100px;
  }
`;

const ToolbarWrapper = styled.div`
  padding: 6px;
`;